var AbstractPlayerView = require("./AbstractPlayerView"),
    Signals            = require("enyo/Signals"),
    frameThrottle      = require("enyo-perf/utils").frameThrottle,
    get                = require("object-path").get,
    kind               = require("enyo/kind");

module.exports = kind(/** @lends  app.MediaPlayer.AudioPlayerSpacer.prototype */ {

    /**
     * @private
     */
    name: "app.MediaPlayer.AudioPlayerSpacer",

    /**
     * @private
     */
    classes: "app-media-player-audio-player-spacer",

    /**
     * @private
     */
    components: [{
        kind:                 Signals,
        onMediaPlayerResized: "onMediaPlayerResized"
    }],

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.lazyReflow = frameThrottle(this.bindSafely(this.reflow));
            sup.apply(this, arguments);
        };
    }),

    /**
     * @protected
     */
    onMediaPlayerResized: function() {
        this.lazyReflow();
    },

    /**
     * @returns  {number}  The current mediaplayer height
     * @private
     */
    getMediaPlayerHeight: function() {
        var $appState       = this.app.$.state,
            mediaPlayerView = get($appState, "mediaPlayerController.view", null),
            mediaPlayerNode = mediaPlayerView instanceof AbstractPlayerView
                ? mediaPlayerView.hasNode()
                : null;

        if (mediaPlayerNode) {
            return mediaPlayerNode.offsetHeight;
        }
        else {
            return 0;
        }
    },

    /**
     * @private
     */
    reflow: function() {
        var $appState     = this.app.$.state,
            currentHeight = this.get("repeaterSize"),
            newHeight;

        // We have an audio player showing in footer mode, so we need to match
        // it's height.
        if ($appState.get("mediaPlayerDisplayMode") === "footer") {
            newHeight = Math.round(this.getMediaPlayerHeight());
        }

        // We don't have an audio player showing in footer mode so we don't need
        // to make room for one.
        else {
            newHeight = 0;
        }

        if (newHeight !== currentHeight) {
            this.addStyles({
                minWidth: "1px",
                height:   newHeight + "px"
            });

            this.repeater.drawChild(this);

            if (this.repeater.arrangeChild(this, this.get("repeaterIndex"))) {
                this.repeater.arrange();
            }
        }
    }

});
